import Box from '@totallymoney/ui/components/Box'
import Button from '@totallymoney/ui/components/Button'
import Flex from '@totallymoney/ui/components/Flex'
import Text from '@totallymoney/ui/components/Text'

interface CardTablePaginationProps {
    numberOfCardsToShow: number
    onShowMoreResults: () => void
    showMoreResultsButton: boolean
    totalCreditCards: number
}

const CardTablePagination = ({
    numberOfCardsToShow,
    totalCreditCards,
    showMoreResultsButton,
    onShowMoreResults,
}: CardTablePaginationProps) => {
    return (
        <>
            {showMoreResultsButton ? (
                <Flex justifyContent="center" mb="space20">
                    <Button
                        variant="secondaryOutline"
                        onClick={onShowMoreResults}
                    >
                        Show more results
                    </Button>
                </Flex>
            ) : null}
            <Flex justifyContent="flex-end">
                <Text variant="80">
                    Showing{' '}
                    <strong>
                        {numberOfCardsToShow > totalCreditCards
                            ? totalCreditCards
                            : numberOfCardsToShow}
                    </strong>{' '}
                    of <strong>{totalCreditCards}</strong> cards
                </Text>
            </Flex>
        </>
    )
}

export default CardTablePagination
